import { render } from "./CardTable.vue?vue&type=template&id=a6eb8a5e"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"
script.render = render

export default script